import { createContext, useContext, MutableRefObject } from 'react';

interface AnimatedTableScrollContextValue {
  scrollOffsetYRef: MutableRefObject<number>;
}

export const AnimatedTableScrollContext = createContext<AnimatedTableScrollContextValue | null>(null);

export const useAnimatedTableScrollOffsetRef = (): MutableRefObject<number> | null => {
  return useContext(AnimatedTableScrollContext)?.scrollOffsetYRef ?? null;
};
